/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StartActivitySessionResponse } from '../../models/start-activity-session-response';

export interface StartActivitySession$Params {
  id: number;
}

export function startActivitySession(http: HttpClient, rootUrl: string, params: StartActivitySession$Params, context?: HttpContext): Observable<StrictHttpResponse<StartActivitySessionResponse>> {
  const rb = new RequestBuilder(rootUrl, startActivitySession.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StartActivitySessionResponse>;
    })
  );
}

startActivitySession.PATH = '/api/activities/{id}/start-session';
